export default __webpack_public_path__ + "static/media/002-milk-products.ec263ab6.svg";